import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { toClassNames } from '@helps/';

import { TestPreview } from './TestPreview';

import {
    FiSidebar,
    FiLock,
    FiX,
    FiColumns,
    FiExternalLink,
    FiMinimize2,
    FiMaximize2,
} from 'react-icons/fi';

import styles from './style.module.scss';

const Test = ({
    open = false,
    onOpenChange = () => {},
    isWide = true,
    onOpenInTab = () => {},
}) => {
    const { schemeId } = useSelector(({ teacher }) => teacher);

    const [hover, setHover] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [type, setType] = useState(null);

    const toggleOpen = () => onOpenChange(!open);

    const headerActions = (
        <div className={styles.actions}>
            <button
                className={styles.action_button}
                onClick={() => onOpenInTab(type)}
                title="Открыть предпросмотр в новой вкладке"
            >
                <FiExternalLink />
                <span>В новой вкладке</span>
            </button>
            {!isWide && (
                <button
                    className={styles.action_button}
                    onClick={() => setCollapsed((prev) => !prev)}
                    title={
                        collapsed
                            ? 'Развернуть на весь экран'
                            : 'Свернуть до половины экрана'
                    }
                >
                    {collapsed ? <FiMaximize2 /> : <FiMinimize2 />}
                    <span>{collapsed ? 'Развернуть' : 'Свернуть'}</span>
                </button>
            )}
            <button
                className={styles.action_button}
                onClick={() => onOpenChange(false)}
                title="Закрыть предпросмотр"
            >
                <FiX />
                <span>Закрыть</span>
            </button>
        </div>
    );

    if (isWide) {
        return open ? (
            <div
                className={toClassNames(
                    styles.mainBlock,
                    styles.mainBlock__split
                )}
            >
                <div
                    className={styles.marker}
                    onClick={toggleOpen}
                    title="Закрыть предпросмотр"
                >
                    <div className={styles.button}>
                        <FiX size={17} />
                    </div>
                </div>
                <div className={styles.test_container}>
                    <TestPreview
                        schemeId={schemeId}
                        type={type}
                        onTypeChange={setType}
                        headerExtra={headerActions}
                        onReturnToEditor={() => onOpenChange(false)}
                    />
                </div>
            </div>
        ) : (
            <div className={styles.split_toggle}>
                <div
                    className={styles.button}
                    onClick={toggleOpen}
                    title="Открыть предпросмотр рядом с редактором"
                >
                    <FiColumns size={17} />
                </div>
                <div
                    className={styles.button}
                    onClick={() => onOpenInTab(type)}
                    title="Открыть предпросмотр в новой вкладке"
                >
                    <FiExternalLink size={17} />
                </div>
            </div>
        );
    }

    return (
        <div
            className={toClassNames(
                styles.mainBlock,
                (open || hover) && styles.mainBlock__active,
                collapsed && styles.mainBlock__collapsed
            )}
        >
            <div
                className={styles.marker}
                onClick={toggleOpen}
                onMouseLeave={() => setHover(false)}
                onMouseEnter={() => setHover(true)}
                title={open ? 'Закрыть предпросмотр' : 'Открыть предпросмотр'}
            >
                <div className={styles.button}>
                    {open ? <FiLock size={17} /> : <FiSidebar size={17} />}
                </div>
            </div>
            <div
                className={styles.test_container}
                onMouseLeave={() => setHover(false)}
                onMouseEnter={() => setHover(true)}
            >
                <TestPreview
                    schemeId={schemeId}
                    type={type}
                    onTypeChange={setType}
                    headerExtra={headerActions}
                    onReturnToEditor={() => onOpenChange(false)}
                />
            </div>
        </div>
    );
};

export { Test };
